import React from 'react';
import ActionsBlock from './components/datatable/ActionsBlock';
import * as DatesUtils from '../../utils/dates';
import { Languages } from '../../config';

const CONFIGURATION = {};

export const allowedActions = {};

export default CONFIGURATION;
//Columns
/*
    message_outgoing_id 
   applicant_id 
    , file_name 
    , message_text 
    , message_type 
    , originating_country 
    , destination_country 
    , message_id 
    , correlation_id 
    , ccncsi_correlation_id 
    , status 
    , error 
    , sent_flag 
    , read_flag 
    , message_ref_id 
    , transmision_date 
    , created_by 
    , created_at 
    , modified_by 
    , modified_at
     */
//table key
//message_outgoing_id
export const TableColumns = [
  {
    label: '#',
    id: 'message_outgoing_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Message ID',
    id: 'message_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Applicant ID',
  //   id: 'applicant_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'File name',
  //   id: 'file_name',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Destination Country',
    id: 'destination_country',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Message Type',
    id: 'message_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Originating country',
  //   id: 'originating_country',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'correlation_id',
  //   id: 'correlation_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'ccncsi_correlation_id',
  //   id: 'ccncsi_correlation_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Status',
    id: 'status',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color: cellValue === 1 ? 'red' : 'black',
            // fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
          }}
        >
          {cellValue === 0
            ? data[rowIndex].sent_flag === 1
              ? 'SENT'
              : 'NOT SENT'
            : data[rowIndex].error
            ? 'ERROR (SYSTEM)'
            : 'ERROR (PROCESSING)'}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'error',
  //   id: 'error',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'Sent flag',
  //   id: 'sent_flag',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'Read flag',
  //   id: 'read_flag',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Transmision Date',
    id: 'transmision_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reference',
    id: 'message_ref_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
    ),
    inData: true,
  },

  // {
  //   label: 'created_by',
  //   id: 'created_by',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'created_at',
  //   id: 'created_at',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'modified_by',
  //   id: 'modified_by',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'modified_at',
  //   id: 'modified_at',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        rowIndex={rowIndex}
        error={data[rowIndex].error}
        message_outgoing_id={data[rowIndex].message_outgoing_id}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Message Outgoing List',
    [Languages.English]: 'Message Outgoing List',
  },
  view_xml: {
    [Languages.Greek]: 'View',
    [Languages.English]: 'View',
  },
  view_error: {
    [Languages.Greek]: 'Error',
    [Languages.English]: 'Error',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  messageId: {
    [Languages.Greek]: 'Message ID',
    [Languages.English]: 'Message ID',
  },
  destinationCountry: {
    [Languages.Greek]: 'Destination Country',
    [Languages.English]: 'Destination Country',
  },
  messageType: {
    [Languages.Greek]: 'Message Type',
    [Languages.English]: 'Message Type',
  },
  status: {
    [Languages.Greek]: 'Status',
    [Languages.English]: 'Status',
  },
};

export const MessageOutgoingStatus = [
  {
    id: '0',
    label: 'IS SENT',
  },
  {
    id: '1',
    label: 'IS NOT SENT',
  },
  {
    id: '2',
    label: 'ERROR (SYSTEM)',
  },
  {
    id: '3',
    label: 'ERROR (PROCESSING)',
  },
];
